import { loadStripe, type Stripe } from "@stripe/stripe-js";

// The publishable key (pk_...) is public — safe to ship to the browser. Configured per
// environment via Vite (VITE_STRIPE_PUBLISHABLE_KEY). loadStripe caches internally, so
// this single shared promise initialises Stripe.js once for the whole app.
// Checking the pk_ prefix rather than mere presence also catches an unexpanded pipeline variable:
// Azure DevOps passes an undefined $(StripePublishableKey) through as its own literal text, which is
// truthy and would otherwise be baked into the bundle.
const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

export const stripePromise: Promise<Stripe | null> = publishableKey?.startsWith("pk_")
  ? loadStripe(publishableKey)
  : Promise.resolve(null);
